/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponsePeopleProfileData } from './genericApiResponsePeopleProfileData';
import type { GenericApiResponsePeopleProfileMessage } from './genericApiResponsePeopleProfileMessage';
import type { GenericApiResponsePeopleProfilePagination } from './genericApiResponsePeopleProfilePagination';
import type { GenericApiResponsePeopleProfileError } from './genericApiResponsePeopleProfileError';

export interface GenericApiResponsePeopleProfile {
  data?: GenericApiResponsePeopleProfileData;
  message?: GenericApiResponsePeopleProfileMessage;
  pagination?: GenericApiResponsePeopleProfilePagination;
  error?: GenericApiResponsePeopleProfileError;
  statusCode?: number;
}
